import * as React from "react";
import { forwardRef } from "react";
const TrafficSignIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 25",
  fill: "currentColor",
  "aria-hidden": "true",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  d: "M12.006 14.118a.75.75 0 0 1 .75.75v.006a.75.75 0 1 1-1.506-.006.75.75 0 0 1 .75-.75h.006zM12 7.384a.75.75 0 0 1 .75.75v4.334a.75.75 0 1 1-1.5 0V8.134a.75.75 0 0 1 .75-.75z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M9.788 4.061a2.56 2.56 0 0 1 4.423 0l5.894 10.199c.984 1.702-.249 3.825-2.212 3.825H14.35v4.25a.75.75 0 1 1-1.5 0v-4.25h-1.8v4.25a.75.75 0 0 1-1.5 0v-4.25H6.106c-1.963-.001-3.194-2.123-2.211-3.825L9.788 4.061zm3.124.751a1.055 1.055 0 0 0-1.825 0L5.193 15.011a1.05 1.05 0 0 0 .912 1.574h11.788a1.05 1.05 0 0 0 .913-1.574L12.912 4.812z"
}));
const ForwardRef = forwardRef(TrafficSignIcon);
export default ForwardRef;